import * as React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { routes as ROUTES } from "./Routes";
import ErrorBoundary from "./components/ErrorBoundary";

import RouteWithSubRoutes from "./components/RouteWithSubRoutes";
import BasePage from "./pages/BasePage";

import * as test from "./utils/authenticatedRequest";

console.log(ROUTES);
console.log(test);

class App extends React.Component {
	render() {
		return (
			<React.StrictMode>
				<ErrorBoundary>
					<Router>
						<>
							<BasePage>
								<Switch>
									{ROUTES.map((route, i) => (
										<RouteWithSubRoutes
											key={i}
											{...route}
										/>
									))}
								</Switch>
							</BasePage>
						</>
					</Router>
				</ErrorBoundary>
			</React.StrictMode>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx